import { useEffect, useRef, useState } from "react";
import { ViewGMPCourseFormData } from "./data/ViewGMPCourseForm.Data";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import MolGrid from "../../components/Grid/MolGrid";
import { ViewGMPCourseTableConfig } from "./data/ViewGMPCourseTableConfig";
import { useGetAllApprovedCourseProviderListMutation } from "../../app/services/GMPCourseProvider/GMPCoursePoviderApi";
import { encryptAESID } from "../../utils/Encryption";

const ViewGmpCourseTaskList = () => {
  const molGridRef = useRef();
  const GmpCorseProviderRef = useRef();
  const [formData, setFromData] = useState(ViewGMPCourseFormData);
  const [dataSource, setDataSource] = useState();
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
    organisationName: "",
    uENNumber: "",
  });
  const [
    getAllApprovedCourseProviderList,
    {
      isSuccess: isSuccessApprovedCourseProviderList,
      isLoading: isLoadingApprovedCourseProviderList,
      data: approvedCourseProviderListData,
    },
  ] = useGetAllApprovedCourseProviderListMutation();

  useEffect(() => {
    getAllApprovedCourseProviderList(paginationRequest);
  }, []);

  useEffect(() => {
    if (
      !isLoadingApprovedCourseProviderList &&
      isSuccessApprovedCourseProviderList &&
      approvedCourseProviderListData
    ) {
      setPaginationRequest((prev) => ({
        ...prev,
        totalCount: approvedCourseProviderListData.totalCount,
      }));
      setDataSource(approvedCourseProviderListData?.itemList);
    }
  }, [
    isLoadingApprovedCourseProviderList,
    isSuccessApprovedCourseProviderList,
    approvedCourseProviderListData,
  ]);

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = { ...paginationRequest, pageNo: pageNumber, pageSize: pageSize };
    setPaginationRequest(updatedPaginationRequest);
    getAllApprovedCourseProviderList(updatedPaginationRequest);
  };

  const handleSearch = () => {
    if (!GmpCorseProviderRef.current) {
        return
      }
    const viewGmpFormData = GmpCorseProviderRef.current.getFormData();
    const updatedPaginationRequest = {
      PageNo: 1,
      PageSize: 20,
      CourseProviderName: viewGmpFormData?.organisationName || "",
      UENNumber:viewGmpFormData?.uENNumber || ""
    };
    setPaginationRequest(updatedPaginationRequest)
    getAllApprovedCourseProviderList(updatedPaginationRequest);
  }
  const handleClearClick = () => {
    const updatedFormData = { ...formData };
    updatedFormData.initialState = {
      uENNumber: null,
      organisationName: null,
    };
  
    const request = {
      ...paginationRequest,
      CourseProviderName: null,
      UENNumber: null,
      totalCount: 0,
    };
  
    setPaginationRequest((prev) => ({ ...prev, ...request }));
    getAllApprovedCourseProviderList(request);
    setFromData(updatedFormData);
  };
  const handleProcessClick = (data) => {
      window.open(`/editCourse/${encryptAESID(data.gmpCourseProviderId)}`)
  }
  const actionHandler = {
    Process: handleProcessClick,
  };
  return (
    <div>
      <div className="form-section">
        <div className="row">
          <div className="row col-10">
            <FormCreator ref={GmpCorseProviderRef} {...formData} />
          </div>
          <div className="btn-sec col-2 mt-auto mb-2 course-search-btn">
            <Buttons
              buttonText="Clear"
              buttonTypeClassName="btn success-btn ml-auto mr-0 "
              onClick={handleClearClick}
            />
            <Buttons
              buttonText="Search"
              buttonTypeClassName="btn success-btn  ml-auto mr-0 mt-3"
              onClick={handleSearch}
            />
          </div>
        </div>
      </div>
      <div className="mt-4">
        <MolGrid
          ref={molGridRef}
          configuration={ViewGMPCourseTableConfig}
          dataSource={dataSource}
          allowPagination={true}
          pagination={paginationRequest}
          onPageChange={handlePageChange}
          onActionChange={actionHandler}
        />
      </div>
    </div>
  );
};

export default ViewGmpCourseTaskList;
